/**
 * @prettier
 */

/**
 * Determines if an image should be cropped or not
 * @param cropSettings
 * @param documentName
 *
 * @returns bool
 */
export function applyCropSettings(cropSettings, documentName) {
    let isCropped = false;

    if (documentName === 'Passport') {
        isCropped = cropSettings.passport;
    } else if (
        ['Drivers License', 'Identification Card', 'Paper Licence'].includes(
            documentName
        )
    ) {
        isCropped = cropSettings.id_card;
    } else {
        return isCropped;
    }
    return isCropped;
}

export function isTwoPagePassport(disabled, documentName) {
    return disabled === 0 && documentName === 'Passport';
}

/**
 * Shared retry payload for Acuant and Regula result pages.
 * Resolves which document to recapture and whether the retry is an expired two-page passport.
 */
export function getRetryDocumentUploadPayload(state, props) {
    const documentId = state.isAcceptedDoc
        ? state.document.id
        : props.userSelectedCardType;

    return {
        documentId,
        isExpiredTwoPagePassport:
            isTwoPagePassport(props.onePagePassport, state.document.name) &&
            Boolean(state.expired),
        navigation: {
            action: 'next',
            props: {
                isRetry: true,
                documentId,
                sidesLeft: props.sidesLeft,
            },
        },
    };
}

/**
 * Applies the shared retry side-effects and returns navigation for the recapture flow.
 * Card type is resolved before resetIDProperties so the selected document is preserved.
 */
export function applyRetryDocumentUpload(state, props, thisSideOnly) {
    const payload = getRetryDocumentUploadPayload(state, props);

    if (!thisSideOnly) {
        props.resetIDProperties();
    }

    if (payload.documentId) {
        props.setCardType(payload.documentId);
    }

    props.isExpiredTwoPagePassport(payload.isExpiredTwoPagePassport);

    return payload.navigation;
}

export function getSubmissionType(document) {
    let submissionType = null;

    // Handle Paper licenses
    if (document.name === 'Paper Licence') {
        submissionType = 'paperLicence';
    } else if (
        // Handle two sided documents
        document.pages.single === false &&
        document.pages.number === 2
    ) {
        submissionType = 'processDLDuplex';
    } else if (
        // Handle single sided documents
        document.pages.single === true &&
        document.pages.number === 1
    ) {
        submissionType = 'postImage';
    } else {
        return submissionType;
    }

    return submissionType;
}

// Set document title based on submission state
export function getDocumentTitle(state, completed) {
    if (state.processing) {
        return 'idpal_doc_title_id_preview_processing';
    } else if (completed === 1) {
        return 'idpal_doc_title_message_complete';
    } else if (state.validation.validated && !state.expired && !state.failed) {
        return 'idpal_doc_title_id_preview';
    } else {
        return 'idpal_doc_title_id_preview_retry';
    }
}
